//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ErrorKind {

  Unspecified = 0,

  FieldValidation = 1,

  UnableToCreateUser = 2,

  NotFound = 3,

  OrderFailed = 4,

}

export default ErrorKind;